module.exports = __webpack_public_path__ + "028589fc9f381af15f0f2b98cf2f35bb.svg";